export class NetworkError extends Error {
  type = 'NetworkError'

  constructor(name: string, message: string, ...args: any) {
    super(...args, message)
    Object.setPrototypeOf(this, NetworkError.prototype)
    this.name = name
  }
}

export class BlockingError extends Error {
  type = 'BlockingError'

  constructor(name: string, message: string, ...args: any) {
    super(...args, message)
    Object.setPrototypeOf(this, BlockingError.prototype)
    this.name = name
  }
}

export class IncorrectLoggedInUserError extends Error {
  type = 'IncorrectLoggedInUserError'

  constructor(name: string, message: string, ...args: any) {
    super(...args, message)
    Object.setPrototypeOf(this, BlockingError.prototype)
    this.name = name
  }
}

export type CustomError = Error & { type: 'BlockingError' | 'NetworkError' | 'IncorrectLoggedInUserError' | 'Error' }
